import PropTypes from 'prop-types'
import React from 'react'

import Icon from '../Icon/Icon'

const colorModeToColor = {
  light: 'white',
  dark: '#004152'
}

function A11yIconLink({ ariaLabel, className = '', colorMode = 'light', href }) {
  const color = colorModeToColor[colorMode] || colorModeToColor.light
  return (
    <a aria-label={ariaLabel} className={`a11y-icon-link ${className}`} href={href} target="_blank">
      <Icon ariaHidden size="original" style={{ color }} type="a11y" />
    </a>
  )
}

A11yIconLink.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  colorMode: PropTypes.oneOf(['light', 'dark']),
  href: PropTypes.string.isRequired
}

export default A11yIconLink
